import HealthTrend from './HealthTrend'

export default HealthTrend
